<script>
  export default {
    name: "AppCursor",
    mounted() {
      let cursor = document.getElementById("cursor");
      let lastX = 0;
      let lastY = 0;
      let lastClientY = 0;

      const cursorFollow = (x, y) =>{
        cursor.style.opacity = 0.9;
        cursor.style.transform = `translateX(${x-10}px) translateY(${y + -10}px)`;
        cursor.style.transition = "0.15s";
      };

      document.addEventListener('mousemove', (e) =>{
        lastX = e.pageX;
        lastY = e.pageY;
        lastClientY = e.clientY;
        cursorFollow(lastX, lastY);
      });

      window.addEventListener('scroll', () => {
        cursorFollow(lastX, lastClientY + window.scrollY);
      });

      window.addEventListener('mouseout', (e) =>{
        if (!e.relatedTarget && !e.toElement) {
          cursor.style.opacity = 0;
        }
      });
    }
  }
</script>

<template>
  <div id="cursor"></div>
</template>

<style>
  #cursor{
    width: 20px;
    height: 20px;
    background-color: rgba(255, 255, 240, 0.9);
    border-radius: 40px;
    position: absolute;
    z-index: 100;
    pointer-events: none;
  }

  @media (max-width: 480px) {
    #cursor{display: none;}
  }
</style>